import React, { useEffect, useState } from "react";
import { Button, Form } from "react-bootstrap";
import { useFormik } from "formik";
import * as Yup from "yup";
import globalVariables from "../../global-variables";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { FocusError } from "focus-formik-error";
import {Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';

export default function Newsletter() {
  const navigate = useNavigate();

  const [modal, setModal] = useState(false);

  const toggle = () => setModal(!modal);

  const formik = useFormik({
    initialValues: {
      email: "",
      topics: [],
    },

    validationSchema: Yup.object({
      email: Yup.string()
        .email("please enter valid email address")
        .required("please enter email Id"),
      topics: Yup.array().min(1, "please select at least one topic"),
    }),

    onSubmit: async (values) => {
      console.log(values);

      const payload = {
        sub_email: values.email,
        sub_topics: values.topics.join(", "),
      };

      await fetch(
        `${globalVariables.variables.strApiUrl}/subscriptionApi/addSubcription`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(payload),
        },
      );
      formik.resetForm();
      setModal(true);
    },
  });

  const [subscriptionTopic, setSubscriptionTopicList] = useState([]);

  useEffect(() => {
    let _obj = new Object();
    _obj.sub_topic_status = 1;

    axios
      .post(
        globalVariables.variables.strApiUrl +
          "/subscriptionTopicApi/getSubscriptionTopicList",
        _obj,
      )
      .then((response) => {
        if (response.data === "error") {
          navigate("/error-page");
        } else {
          if (response.data[0].length > 0) {
            setSubscriptionTopicList(response.data[0]);
          }
        }
      });
  }, []);

  const handleCheckboxChange = (topic) => {
    const currentTopics = formik.values.topics;

    if (currentTopics.includes(topic)) {
      formik.setFieldValue(
        "topics",
        currentTopics.filter((x) => x !== topic),
      );
    } else {
      formik.setFieldValue("topics", [...currentTopics, topic]);
    }
  };

  return (
    <>
      <h2 className="h1 fw-light text-primary wow fadeInUp mb-3">
        Subscribe for GESH updates
      </h2>

      <Form onSubmit={formik.handleSubmit}>
        {/* formik focus error blog if error occurs in validation */}
          <FocusError formik={formik} />

        {/* Email */}

        <Form.Group className="mb-4 w-75">
           
          <Form.Control
            type="text"
            name="email"
            placeholder="Enter email"
            value={formik.values.email}
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            isInvalid={formik.touched.email && formik.errors.email}
          />{" "}
          <Form.Control.Feedback type="invalid">
            {" "}
            {formik.errors.email}{" "}
          </Form.Control.Feedback>{" "}
        </Form.Group>

        {/* Topics */}

        <div className="mb-4">
          {subscriptionTopic?.map((topic) => {
            const isSelected = formik.values.topics.includes(
              topic.sub_topic_title,
            );

            return (
              <label
                key={topic.sub_topic_id}
                onClick={() => handleCheckboxChange(topic.sub_topic_title)}
                className="me-2 mb-2"
                style={{
                  padding: "5px 10px",
                  borderRadius: "4px",
                  cursor: "pointer",
                  userSelect: "none",
                  transition: "0.2s",
                  border: isSelected
                    ? "1px solid #7fa35a"
                    : "1px solid #d9d9d9",
                  background: isSelected ? "#7fa35a" : "#dcdcdc",
                  color: isSelected ? "#fff" : "#555",
                  display: "inline-block",
                  fontSize: "15px",
                  fontWeight: "500",
                }}
              >
                {topic.sub_topic_title}
              </label>
            );
          })}

          {formik.errors.topics && formik.submitCount > 0 && (
            <div className="text-danger mt-2" style={{ fontSize: "14px" }}>
              {formik.errors.topics}
            </div>
          )}
        </div>

        {/* Submit */}

        <div className="text-start">
          <Button type="submit" className="rounded-pill px-4 py-2">
            Submit
          </Button>
        </div>
      </Form>
      <Modal isOpen={modal} toggle={toggle} centered>
          <ModalBody className='d-flex flex-column justify-content-center align-items-center py-5'>
              <h3>Thank You</h3> 
              <p className='mb-3'>For subscribing to the GESH updates</p>
              <Button className="rounded-pill px-4 py-2" onClick={toggle}>
              OK
          </Button>
          </ModalBody>
      </Modal>
    </>
  );
}
